const categorySlider = document.querySelector('.category-slider');

const airFilter = categorySlider?.querySelector('.air-filter.carousel-cell');
console.log("inside testing", airFilter)
if ($(window).width() > 768){
  console.log("inside if")
  if(airFilter){
    airFilter.remove();
  }
  
}


$('.category-slider').slick({
    speed: 500,
    slidesToShow: 2.1,
    slidesToScroll: 1,
    infinite: false,
    dots: false,
    prevArrow: '<button class="slick-prev"><svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="18" cy="18" r="17.5" transform="rotate(180 18 18)" fill="white" stroke="#BEBEBE"/><path d="M14 25L21 18L14 11" stroke="black" stroke-width="1.5"/></svg></button>',
    nextArrow: '<button class="slick-next"><svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="18" cy="18" r="17.5" transform="rotate(180 18 18)" fill="white" stroke="#BEBEBE"/><path d="M14 25L21 18L14 11" stroke="black" stroke-width="1.5"/></svg></button>',
    responsive: [
      {
        breakpoint: 1205,
        settings: {
          slidesToShow: 3.1,
          slidesToScroll: 1,
          arrows: true
        }
      },
        {
          breakpoint: 790,
          settings: {
            slidesToShow: 2.1,
            slidesToScroll: 1,
            arrows: false
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2.1,
            slidesToScroll: 1,
            arrows: false
          }
        }
      ]
});



